import SectionHeading from "./SectionHeading";
import { resourceEntries } from "@/mocks/home";

export default function ResourceEntries() {
  return (
    <section id="resources" className="w-full bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          badge="Hub"
          title="51cg5 资源入口 · 一站直达"
          desc="榜单、档案、雷达与看板集中在一个入口层，常用功能点一下就能到。"
          linkText="打开全部入口"
          linkHref="#resources"
        />

        <div className="relative mb-6 overflow-hidden rounded-lg border border-background-200/70">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20warm%20orange%20radar%20interface%20concept%20with%20glowing%20concentric%20circles%20and%20data%20points%20on%20dark%20warm%20background%2C%20stylized%20digital%20art%2C%20clean%20futuristic%20composition&width=1200&height=700&seq=resource-feature-01&orientation=landscape"
            alt="爆点雷达 - 实时监测全网红点异动"
            title="爆点雷达 - 51cg5 实时热度监测"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>
          <div className="relative flex flex-col gap-4 p-6 md:flex-row md:items-center md:justify-between md:p-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-bold text-background-50">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-radar-line"></i>
                </span>
                精选入口
              </span>
              <h3 className="mt-3 font-heading text-xl font-black text-background-50 md:text-2xl">
                爆点雷达 · 实时监测全网红点异动
              </h3>
              <p className="mt-2 text-sm text-background-100/90">
                自动识别热度异常上升的话题，把正在起势的焦点第一时间推到你面前。
              </p>
            </div>
            <a
              href="#ranking"
              className="inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-background-200"
            >
              立即查看
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {resourceEntries.map((entry) => (
            <a
              key={entry.id}
              href="#resources"
              className="group flex cursor-pointer flex-col rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <span className="mt-3 font-heading text-sm font-bold text-foreground-950 md:text-base">{entry.title}</span>
              <span className="mt-1 text-xs text-foreground-600">{entry.desc}</span>
              <span className="mt-3 text-[11px] font-medium text-secondary-500">{entry.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}